module.exports = {"513330100":"更庆镇","513330101":"马尼干戈镇","513330102":"竹庆镇","513330103":"阿须镇","513330105":"错阿镇","513330106":"麦宿镇","513330107":"打滚镇","513330108":"龚垭镇","513330109":"温拖镇","513330110":"中扎科镇","513330202":"岳巴乡","513330203":"八帮乡","513330205":"白垭乡","513330206":"汪布顶乡","513330207":"柯洛洞乡","513330208":"卡松渡乡","513330209":"俄南乡","513330211":"俄支乡","513330213":"玉隆乡","513330216":"上燃姑乡","513330219":"年古乡","513330220":"浪多乡","513330223":"亚丁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513330.json
// module id = 2552
// module chunks = 0